import React, { Fragment, useEffect, lazy, Suspense } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { trackEvent, handleMediaQuery } from '@offerzen/pinata-shame'

import { useCaptureUTM, useDocumentTitle, useRedirectToOnboarding } from '../CandidateExperience/hooks'

import LoadingScene from '../CandidateExperience/scenes/LoadingScene'
import { errorUser } from '../CandidateExperience/selectors/currentUser'
import ReapplyModal from './components/ReapplyModal'
import ReapplyTracking from './containers/ReapplyTracking'

const Dashboard = lazy(() => import(/* webpackPrefetch: true */ './components/Dashboard'))

const renderReapplyModal = () => (
  <ReapplyTracking>
    {({ candidateId, trackReapplyModal }) => <ReapplyModal candidateId={candidateId} trackReapplyModal={trackReapplyModal} />}
  </ReapplyTracking>
)

const DashboardMain = props => {
  useRedirectToOnboarding(props.candidate)
  useCaptureUTM(props.location.search)

  useDocumentTitle('Dashboard - OfferZen')

  useEffect(() => {
    trackEvent('candidate-dashboard-accessed')
  }, [])

  return (
    <Switch>
      <Route
        exact
        path="/candidate/:id/dashboard"
        render={() => (
          <Fragment>
            {renderReapplyModal()}
            <Suspense fallback={<LoadingScene showNav={false} />}>
              <Dashboard {...props} />
            </Suspense>
          </Fragment>
        )}
      />
    </Switch>
  )
}

const mapStateToProps = state => ({
  errorUser: errorUser(state),
  candidate: state.candidate,
  dashboard_state: state.dashboard_state,
})

export default handleMediaQuery()(withRouter(connect(mapStateToProps)(DashboardMain)))
